var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 16C5.55518 16 3.3125 13.7573 3.3125 11V4C3.3125 3.63135 3.61121 3.33337 3.97913 3.33337C4.34717 3.33337 4.64587 3.63135 4.64587 4V11C4.64587 13.0214 6.29053 14.6666 8.3125 14.6666C10.3345 14.6666 11.9791 13.0214 11.9791 11V3.66663C11.9791 2.38 10.9325 1.33337 9.64587 1.33337C8.35913 1.33337 7.3125 2.38 7.3125 3.66663V10.3334C7.3125 10.8846 7.76111 11.3334 8.3125 11.3334C8.86389 11.3334 9.3125 10.8846 9.3125 10.3334V4C9.3125 3.63135 9.61121 3.33337 9.97913 3.33337C10.3472 3.33337 10.6459 3.63135 10.6459 4V10.3334C10.6459 11.62 9.59912 12.6666 8.3125 12.6666C7.02588 12.6666 5.97913 11.62 5.97913 10.3334V3.66663C5.97913 1.64539 7.62378 0 9.64587 0C11.6678 0 13.3125 1.64539 13.3125 3.66663V11C13.3125 13.7573 11.0698 16 8.3125 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipIcn);
export default __webpack_public_path__ + "static/media/clip-icn.bea4a59705e9f3446416ef094ea4c474.svg";
export { ForwardRef as ReactComponent };